
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/battery",
      function () {
        return require("private-next-pages/battery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/battery"])
      });
    }
  